<template>
  <div>
    <section class="section">
      <div class="container is-fluid">
        <vue-cal
          :disable-views="['years', 'year', 'day']"
          :events-on-month-view="true"
          :showAllDayEvents="true"
          :events="events"
          default-view="month"
          :on-event-click="onEventClick"
          :time-from="7 * 60"
          :time-to="23 * 60"
        ></vue-cal>
      </div>
      <div
        class="modal calendar-modal-background"
        @click="showEventBox = false"
        :class="{'is-active':showEventBox}"
      >
        <div class="modal-content box">
          <h2 v-if="selectedEvent.type == 'project'" class="subtitle">{{ selectedEvent.title }}</h2>
          <h2
            v-if="selectedEvent.type == 'booking'"
            class="subtitle"
          >{{ selectedEvent.title }} with {{selectedEvent.name}}</h2>
          <h2 v-if="selectedEvent.type == 'todo'" class="subtitle">{{ selectedEvent.brief }}</h2>
          <p
            v-if="selectedEvent.class != 'passed'"
          >Due on {{selectedEvent.endDate}}. {{ remainingDays(selectedEvent.endDate) }}</p>
        </div>
        <button class="modal-close is-large" @click="showEventBox = false" aria-label="close"></button>
      </div>
    </section>
    <section class="section">
      <div class="container is-fluid">
        <div class="columns is-centered">
          <div class="column">
            <div class="columns">
              <div class="column is-10 is-offset-2">
                <div class="columns has-text-left">
                  <div class="column is-4">Task</div>
                  <div class="column is-4">Due Date</div>
                  <div class="column is-4">Action</div>
                </div>
              </div>
            </div>
            <div v-for="(event, i) in onlyFuture(eventsList)" :key="i">
              <listItem @todoBriefClicked="onTodoBriefClick" :event="event"></listItem>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VueCal from "vue-cal";
import ListItem from "@/components/calendar/ListItem";
import { CalendarClient } from "../clients/CalendarClient";
// import { CourseClient } from "../clients/CourseClient";

export default {
  name: "Calendar",
  components: { VueCal, ListItem },
  data() {
    return {
      rawEvents: Array,
      events: [],
      user: this.$store.state.auth.user,
      selectedEvent: {},
      showEventBox: false,
      bookings: [],
      projects: [],
      todos: []
    };
  },
  computed: {
    eventsList() {
      let sortingList = this.events;
      return sortingList.sort(function(a, b) {
        return new Date(a.end) - new Date(b.end);
      });
    }
  },

  methods: {
    onTodoBriefClick(event) {
      this.selectedEvent = event;
      this.showEventBox = true;
    },
    onlyFuture(events) {
      let sortingList = events;
      let tempList = [];
      sortingList.forEach(element => {
        if (this.pastOrFuture(element.start) == "upcoming") {
          tempList.push(element);
        }
      });
      return tempList.sort(function(a, b) {
        return new Date(a.end) - new Date(b.end);
      });
    },
    dateDiffInDays(a, b) {
      const _MS_PER_DAY = 1000 * 60 * 60 * 24;

      const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
      const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

      return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    },
    remainingDays(date) {
      let today = new Date();
      let projectDate = new Date(date);
      if (projectDate > today) {
        let posDiff = this.dateDiffInDays(today, projectDate);
        if (posDiff > 1) {
          return posDiff + " days left.";
        } else if (posDiff == 1) {
          return "1 day left.";
        } else if (posDiff == 0) {
          return "No days left";
        } else {
          return "date error";
        }
      } else if (projectDate <= today) {
        let negDiff = this.dateDiffInDays(projectDate, today);
        if (negDiff > 1) {
          return negDiff + " days overdue.";
        } else if (negDiff == 1) {
          return "1 day overdue.";
        } else {
          return "No days left.";
        }
      }
    },
    truncate(text) {
      if (text.length < 30) {
        return text;
      } else {
        return text.substring(0, 27) + "...";
      }
    },

    getCalendar() {
      CalendarClient.getCalendar(this.$store.state.auth.user.groups[0].id)
        .then(response => {
          this.rawEvents = response.data.events;
          this.processEvents(this.rawEvents);
          console.log(response);
        })
        .catch(err => {
          console.log(err);
        });
    },
    processDate(date) {
      return this.$moment(date).format("YYYY-MM-DD HH:mm");
    },
    processTodoDate(date) {
      return this.$moment(date)
        .add(30, "minutes")
        .format("YYYY-MM-DD HH:mm");
    },
    pastOrFuture(date) {
      let now = new Date();
      let subject = new Date(date);

      if (subject >= now) {
        return "upcoming";
      } else {
        return "passed";
      }
    },

    onEventClick(event, e) {
      this.selectedEvent = event;
      this.showEventBox = true;
    },
    processEvents(raw) {
      raw.todos.forEach(element => {
        this.todos.push({
          class: this.pastOrFuture(element.due_date),
          end: this.processTodoDate(element.due_date),
          start: this.processDate(element.due_date),
          type: "todo",

          title: this.truncate(element.todo),
          brief: element.todo
        });
      });

      raw.bookings.forEach(element => {
        this.bookings.push({
          name: element.name,
          class: this.pastOrFuture(element.start_date),
          start: this.processDate(element.start_date),
          end: this.processDate(element.end_date),
          title: "Mentor Chat",
          type: "booking"
        });
      });
      raw.projects.forEach(element => {
        this.projects.push({
          class: element.status,
          start: this.processDate(element.project.pivot.due_date),
          end: this.processDate(element.project.pivot.due_date),
          title: element.project.name,
          id: element.project.id,
          brief: element.project.content,
          allDay: true,
          type: "project",
          project: element.project.id,
          status: element.status
        });
      });
      this.todos.forEach(element => {
        this.events.push(element);
      });
      this.bookings.forEach(element => {
        this.events.push(element);
      });
      this.projects.forEach(element => {
        this.events.push(element);
      });
    }

    // setSubmissionStatus(event) {
    //   let today = new Date();
    //   let time = new Date(event.end_date);
    //   if (event.type_entity.submission) {
    //     return "submitted";
    //   } else if (time > today) {
    //     return "outstanding";
    //   } else {
    //     return "overdue";
    //   }
    // }
  },
  mounted() {
    this.getCalendar();
  }
};
</script>


<style lang="scss">
@import "~vue-cal/dist/vuecal.css";
@import "@/assets/scss/variables.scss";
.vuecal--month-view .vuecal__cell {
  min-height: 80px;
}

.vuecal__event-title {
  color: white;
}
.vuecal--month-view .vuecal__cell-content {
  justify-content: flex-start;
  height: 100%;
  align-items: flex-end;
}

.vuecal--month-view .vuecal__cell-date {
  padding: 4px;
}
.vuecal--month-view .vuecal__no-event {
  display: none;
}

.project-submission {
  background-color: orange !important;
}

.outstanding {
  background-color: yellow;
  border-left: 1px solid grey;
  border-right: 1px solid grey;
  .vuecal__event-title {
    color: black;
  }
}
.submitted {
  background-color: green;
  border-left: 1px solid grey;
  border-right: 1px solid grey;
}
.overdue {
  background-color: red;
  border-left: 1px solid grey;
  border-right: 1px solid grey;
}
.passed {
  background-color: $pantoneBlue;
  border-left: 1px solid grey;
  border-right: 1px solid grey;
  color: white !important;
}
.upcoming {
  background-color: $orange;
  border-left: 1px solid grey;
  border-right: 1px solid grey;
}

.calendar-modal-background {
  background-color: transparent !important;
}
</style>


